import React, { useEffect, useState, useMemo, useRef } from "react";
import CustomButton from "../../AppComponent/CustomButton/CustomButton";
import { useDispatch, useSelector } from "react-redux";
import {
  getRoportpostActions,
  //--filer
  setGeoLoactionStateAction,
  setZoneActions,
  setRegionActions,
  setClientBranchSearchAction,
  setOverReportActions,
  SetClientActions,
  resetOrganizationFilterlist,
} from "../../../Redux/Slice";
import correctIcons from "../../../Assets/AppComponent/icons/Group 359.svg";
import Pendingimg from "../../../Assets/AppComponent/icons/Group 145.svg";
import { useNavigate } from "react-router-dom";
import Select from "react-select";
import validator from "validator";
import TagsInput from "react-tagsinput";
import "react-tagsinput/react-tagsinput.css";
import CloseOutlinedIcon from "@material-ui/icons/CloseOutlined";
import { tr } from "date-fns/locale";
import { DateRangePicker, Stack } from "rsuite";
import subDays from "date-fns/subDays";
import startOfWeek from "date-fns/startOfWeek";
import endOfWeek from "date-fns/endOfWeek";
import addDays from "date-fns/addDays";
import "rsuite/dist/rsuite.css";
import isAfter from "date-fns/isAfter";
import $ from "jquery";
import { values } from "lodash";
import useDebouncedEffect from "use-debounced-effect";
import { differenceInDays } from "date-fns";
import { toast } from "react-toastify";

const DENAVE_ORG_ID = "11a8ab83-0669-4098-a453-ddb2a2e0c39e";
const SONY_ORG_ID = "5e8579aa-1ec3-42fd-925d-e8e80d501963";

const ReportCreateSheet = (props) => {
  const {
    show,
    setshow,
    search,
    status,
    dtpageindex,
    fromRange,
    defaultReportType,
  } = props;
  const dispatch = useDispatch();
  const stateDisplay = useSelector(
    (state) => state.SideBarActive.SidebarActive,
  );
  const state = useSelector((state) => state);

  const [emailError, setEmailError] = useState("");
  const UserObjectData = useSelector((state) => state.users.UserData);
  const dateRangeRef = useRef(null);
  const [organizationSelectedList, setOrganizationSelectedList] = useState();
  const [Organization_options, setOrganizations_options] = useState([]);
  const isClient = UserObjectData?.data?.org_ids.some(
    (item) => item.id === "11a8ab83-0669-4098-a453-ddb2a2e0c39e",
  );

  console.log(UserObjectData?.data, "dklasdlkakldklsa");
  const allReportOptions = [
    { value: "user_details", label: "USERS REPORT" },
    { value: "user_role", label: "USERS DESIGNATION REPORT" },
    { value: "user_cost_report", label: "USER COST REPORT" },

    { value: "onboarding_count_details", label: "ONBOARDING SUMMARY" },
    { value: "onboarder_details", label: "ONBOARDER DETAILS" },
    { value: "form_export", label: "FORM EXPORT" },
    { value: "attendance_report", label: "ATTENDANCE REPORT" },
    { value: "Attendance_summary", label: "ATTENDANCE SUMMARY" },

    { value: "attendance_report_pdf", label: "ATTENDANCE MONTHLY REPORT" },
    { value: "Attendance_summary_pdf", label: "ATTENDANCE MONTHLY SUMMARY" },
    { value: "count_report", label: "COUNT REPORT" },
    { value: "on_notice_report", label: "ON NOTICE REPORT" },
    { value: "separation_report", label: "SEPARATION REPORT" },
    { value: "non_working_employee_report", label: "NON WORKING EMPLOYEE REPORT" },
    { value: "denave_self_onboarding_report", label: "DENAVE SELF ONBOARDING REPORT" },
    { value: "sony_bulk_offer_report", label: "SONY BULK OFFER REPORT" },
    { value: "id_card_report", label: "ID CARD EXPORT" },
    // previously only for a few admin emails / Denave users, now given through report_access
    { value: "salary_report", label: "SALARY REPORT" },
  ];
  // only the report types given to the user (User tab -> Report Access); empty = none
  const reportoptions = allReportOptions.filter((opt) =>
    (UserObjectData?.data?.report_access || []).includes(opt.value),
  );

  console.log(isClient, "kldasldkaklsdkl");

  // report can be preselected when coming from the Denave / Sony bulkupload screens
  const defaultReport = reportoptions.find(
    (opt) => opt.value === defaultReportType,
  );
  const [ReportVal, setReportVal] = useState(defaultReport || []);

  const [Name, setName] = useState({
    report_type: defaultReport ? defaultReport.value : "",
  });
  // on notice / separation reports: date range + optional denave branch + email
  const isNoticeOrSeparation =
    Name.report_type === "on_notice_report" ||
    Name.report_type === "separation_report";
  // non working employee report: optional date of leaving range + optional client + email
  const isNonWorking = Name.report_type === "non_working_employee_report";
  // denave self onboarding / sony bulk offer: optional date range + optional multi client + email
  const isDenaveSelf = Name.report_type === "denave_self_onboarding_report";
  const isSonyOffer = Name.report_type === "sony_bulk_offer_report";
  const isOrgClientReport = isDenaveSelf || isSonyOffer;
  // id card report: same filters as the ID card tab - state, region, zone,
  // multi client, optional date range, id card status + email
  const isIdCard = Name.report_type === "id_card_report";
  const [multiClients, setMultiClients] = useState([]);
  const idCardStatusOptions = [
    { value: "", label: "ALL" },
    { value: "pending", label: "Pending" },
    { value: "completed", label: "Completed" },
  ];
  const [idCardStatus, setIdCardStatus] = useState(idCardStatusOptions[0]);
  const [idCardOrganization, setIdCardOrganization] = useState({ value: "", label: "ALL" });
  // ID cards are issued only for these organizations
  const idCardOrganizationOptions = useMemo(() => {
    const allowed = ["uds", "sony", "stanworth"];
    let objectArray = [{ value: "", label: "ALL" }];
    (state.organization_filterlist_tocall.Organization_filterlist_records || []).forEach(
      (element) => {
        const name = (element.organization_name || "").toLowerCase();
        if (allowed.some((item) => name.includes(item))) {
          objectArray.push({
            value: element.id,
            label: element.organization_name.toUpperCase(),
          });
        }
      },
    );
    return objectArray;
  }, [state.organization_filterlist_tocall.Organization_filterlist_records]);

  useEffect(() => {
    setMultiClients([]);
    setIdCardStatus(idCardStatusOptions[0]);
    setIdCardOrganization({ value: "", label: "ALL" });
  }, [Name.report_type]);

  const [nameErr, setNameerr] = useState("");
  const [emailTags, setEmailTags] = useState({ tags: [] });

  const API_reports = [
    { value: "0", label: "ZOHO" },
    { value: "1", label: "ARYA" },
    { value: "2", label: "INVINCIBLE" },
    { value: "3", label: "SANDBOX" },
    { value: "4", label: "GUPSHUP" },
  ];

  const [ClientListVal, setCLientVal] = useState();
  $(document).ready(function () {
    $(".react-tagsinput-input").attr("placeholder", "Enter Email ID");
  });

  const [EmpRoles, setEmplyeRole] = useState([
    // {
    //   value: "",
    //   label: "All",
    // },
    {
      value: "1",
      label: "UDS",
    },
    {
      value: "2",
      label: "CLIENT",
    },
  ]);
  const EmployeeDetails = [
    { value: "0", label: "CURRENT EMPLOYEE" },
    { value: "1", label: "OLD EMPLOYEE" },
  ];
  const [EmployeeDetailsVAL, setemplyoyeeDetails] = useState({
    value: "0",
    label: "CURRENT EMPLOYEE",
  });
  const [old_employeeVal, setoldEmployees] = useState({ old_employee: false });
  // console.log(old_employeeVal ,"13213old_employeeVal");
  const [date_ranges, setdate_ranges] = useState(null);
  const Options = [
    {
      value: "day",
      label: "DAY",
    },
    {
      value: "time",
      label: "TIME",
    },
  ];

  const [OPtionsVal, setOptionsVal] = useState({
    value: "day",
    label: "DAY",
  });
  const [DateFormats, setDateFormate] = useState("day");

  const initialStateSearch = {
    client: "",
    Employeesearch: "",
    stateSearch: "",
    regionSearch: "",
    zoneSearch: "",
    Employeesearch: "",
    client: "",
    parent: "",
    organization_search: "",
  };
  const [SearchedVal, setSearched] = useState(initialStateSearch);
  const initialDebouanceSearch = {
    stateSearch: "",
    regionSearch: "",
    zoneSearch: "",
    client: "",
    Employeesearch: "",
    parent: "",
    organization_search: "",
  };

  const [SearchDebounance, setSearchDebounance] = useState(
    initialDebouanceSearch,
  );

  const [EMpROleSelected, setEmpRoleSele] = useState(EmpRoles[0]);
  const [filterForWhite, setFilters] = useState({ white_collar: true });
  const [data, setData] = useState({
    zone: "",
    state: state.ClientBranchIDs.StateName.value,
    region: "",
  });
  const [State, setState] = useState([]);
  const [multiselect, setMuliselect] = useState([
    //  { value: "", label: "All" }
    state.ClientBranchIDs.StateName,
  ]);
  let [nameList, setOptions] = useState([]);
  const [nameList2, setOptions2] = useState([]);
  const [REgion, setRegion] = useState([]);
  const [multiselect1, setMuliselect1] = useState([]);
  const [multiselect3, setMuliselect3] = useState([]);
  const [nameList4, setOptions4] = useState([]);
  const [Zone, setZone] = useState([]);
  const [fromErr, setFromErr] = useState("");

  const [nameListclient, setOptionsclient] = useState([]);
  const [nameListclientParent, setOptionsclientParent] = useState([]);

  const naviagte = useNavigate();
  const [clients, setclientid] = useState({ client: "", parent: "" });
  const initialStateSearchval = {
    client: "",
    parent: "",
  };
  const [clientvalues, setclientalues] = useState([]);
  const [SearchedValclient, setSearchedclient] = useState(
    initialStateSearchval,
  );
  const [UserReportValue, setUserReportValues] = useState({
    value: "",
    label: "ALL",
  });
  const [UserReportOptions, setUserReportOptions] = useState([]);
  const [UserReportRechargedOptions, setUserReportRechargedOptions] = useState(
    [],
  );
  const [from_export_excel, setfrom_export_excel] = useState({
    label: "ALL",
    value: "",
  });

  const [Servicetyp, setservicetype] = useState({ value: "", label: "ALL" });
  const [Overallstate, setoverallstate] = useState({
    third_party_id: "",
  });
  const [reachargedDtae, settherecargeddate] = useState({
    value: "",
    label: "ALL",
  });
  const [adoption_type, setadoption_type] = useState({
    value: "",
    label: "ALL",
  });
  const adoptions_options = [
    { value: "", label: "ALL" },
    {
      value: "1",
      label: "YES",
    },
    {
      value: "2",
      label: "NO",
    },
  ];

  const [type_of_exports, settype_ofexports] = useState({
    value: "0",
    label: "EXCEL",
  });
  const typeof_exports_options = [
    {
      value: "0",
      label: "EXCEL",
    },
    {
      value: "1",
      label: "PDF",
    },
  ];
  const form_export_excel_options = [
    { label: "ALL", value: "" },
    { label: "KYC COMPLETED", value: "kyc_completed" },
    { label: "AWAITING FOR EMPLOYEE", value: "awaiting_for_employee" },
  ];

  function convert(str) {
    var date = new Date(str),
      mnth = ("0" + (date.getMonth() + 1)).slice(-2),
      day = ("0" + date.getDate()).slice(-2);
    return [date.getFullYear(), mnth, day].join("-");
  }

  var today = new Date();
  var priorDate = new Date(new Date().setDate(today.getDate() - 30));
  var it = convert(today);
  var gt = convert(priorDate);
  const [range, setrange] = useState([]);

  const cleaningrange = () => {
    ///
  };

  const lastElement = range[range.length - 1];
  const secondLastElement = range[range.length - 2];

  const handlechangedate = (e) => {
    // setSelectedDates(e);
    // setrange((oldArray) => [...oldArray, e.slice(0, 10)]);
    setrange((oldArray) => [...oldArray, e.slice(0, 10)]);
  };
  const HandleEMprole = (e) => {
    if (e != null) {
      setEmpRoleSele(e);

      if (e.value == 1) {
        setFilters({
          ...filterForWhite,
          white_collar: true,
        });
      } else if (e.value == 2) {
        setFilters({
          ...filterForWhite,
          white_collar: false,
        });
      } else if (e.value == "") {
        setFilters({
          ...filterForWhite,
          white_collar: "",
        });
      }
    }
  };

  const Handleservicetype = (e) => {
    if (e != null) {
      setservicetype(e);
      // setoverallstate({
      //   ...Overallstate,
      //   third_party_id:e.value
      // })
    }
  };
  const Handletherechareddate = (e) => {
    if (e != null) {
      settherecargeddate(e);
      setoverallstate({
        ...Overallstate,
        third_party_id: e.value,
      });
    }
  };

  useDebouncedEffect(
    () => {
      if (setSearchDebounance) {
        setSearchedclient({
          ...SearchedValclient,
          parent: SearchDebounance.parent,
          client: SearchDebounance.client,
        });
        setSearched({
          ...SearchedVal,
          stateSearch: SearchDebounance.stateSearch,
          regionSearch: SearchDebounance.regionSearch,
          zoneSearch: SearchDebounance.zoneSearch,
          client: SearchDebounance.client,
          Employeesearch: SearchDebounance.Employeesearch,
          organization_search: SearchDebounance.organization_search,
        });
      }
    },
    500,
    [SearchDebounance],
  );

  useEffect(() => {
    const payloads = {
      search: SearchedVal.stateSearch,
      page_size: "",
      page: 1,
    };
    dispatch(setGeoLoactionStateAction(payloads));
    setState(state.GeoState.State);
  }, [SearchedVal.stateSearch]);
  //--------------_Zone---------------
  useEffect(() => {
    const payloads = {
      search: SearchedVal.zoneSearch,
      page_size: 20,
      page: 1,
      counts: 1,
      region_id: data.region,
    };
    dispatch(setZoneActions(payloads));
    setZone(state.ZonePart.Zone);
  }, [data.region, SearchedVal.zoneSearch]);
  useEffect(() => {
    const payload = {
      search: "",
      page_size: "",
      page: 1,
      // api_type:"",
      active: true,
    };
    dispatch(setOverReportActions(payload));
  }, []);

  ////-----third party API
  useEffect(() => {
    if (state.OverAllReportCall.OverAllreportDatas != undefined) {
      let objectArray = [];
      let objectArrayrechargeddate = [];
      objectArrayrechargeddate.push({
        value: "",
        label: "ALL",
      });
      objectArray.push({ value: "", label: "ALL" });
      state.OverAllReportCall.OverAllreportDatas.forEach((element) => {
        console.log(element, "97409e8element");
        objectArray.push({
          value: element.id,
          label:
            element.api_type == "0"
              ? "ZOHO"
              : element.api_type == "1"
                ? "ARYA"
                : element.api_type == "2"
                  ? "INVINCIBLE"
                  : element.api_type == "3"
                    ? "SANDBOX"
                    : element.api_type == "4"
                      ? "GUPSHUP"
                      : "",
        });

        objectArrayrechargeddate.push({
          value: element.id,
          label: element.recharged_date,
        });
      });

      setUserReportOptions(objectArray);

      setUserReportRechargedOptions(objectArrayrechargeddate);
    }
  }, [state.OverAllReportCall.OverAllreportDatas]);

  ///  ///----------------------REgion-----------
  useEffect(() => {
    const Datas = [];
    setRegion(state.regioncall.RegionDat);
    if (state.regioncall.RegionDat != undefined) {
      let objectArray = [];
      state.regioncall.RegionDat.forEach((element) => {
        objectArray.push({
          value: element.id,
          label: element.region_name.toUpperCase(),
        });
      });
      setOptions2(objectArray);
    }
  }, [state.regioncall.RegionDat, SearchedVal.regionSearch]);

  //---------------State0------------------------
  useEffect(() => {
    const Datas = [];
    setState(state.GeoState.State.state_name);
    if (state.GeoState.State != undefined) {
      let objectArray = [];
      state.GeoState.State.forEach((element) => {
        objectArray.push({
          value: element.id,
          label: element.state_name.toUpperCase(),
        });
      });
      setOptions(objectArray);
    }
  }, [state.GeoState.State, SearchedVal.stateSearch]);

  //-----Region---------
  useEffect(() => {
    const payloads = {
      search: SearchedVal.regionSearch,
      page_size: 20,
      page: 1,
      counts: 1, //-----only we ----get----the----selected regions , the--id only
      state: data.state,
    };
    dispatch(setRegionActions(payloads));
    //console.log(State.regioncall.RegionDat, "states", State.regioncall.Total_Count);
    setRegion(state.regioncall.RegionDat);
  }, [data.state, SearchedVal.regionSearch]);

  ///-------------Zone--------------
  useEffect(() => {
    const Datas = [];
    setZone(state.ZonePart.Zone);
    if (state.ZonePart.Zone != undefined) {
      let objectArray = [];
      state.ZonePart.Zone.forEach((element) => {
        objectArray.push({
          value: element.id,
          label: element.zone_name.toUpperCase(),
        });
      });
      setOptions4(objectArray);
    }
  }, [state.ZonePart.Zone, SearchedVal.zoneSearch]);

  ////---Client-----Branch====--based----filter
  useEffect(() => {
    if (isNonWorking || isNoticeOrSeparation || isOrgClientReport) {
      // no parent for these reports: load branches directly by organization
      const payload = {
        search: SearchedValclient.client,
        page_size: 20,
        page: 1,
        data: data,
        organization: isSonyOffer ? SONY_ORG_ID : DENAVE_ORG_ID,
      };
      dispatch(setClientBranchSearchAction(payload));
    } else if (isIdCard) {
      const payload = {
        search: SearchedValclient.client,
        page_size: 20,
        page: 1,
        data: data,
        organization: idCardOrganization.value,
      };
      dispatch(setClientBranchSearchAction(payload));
    } else if (clients.parent != "") {
      const payload = {
        search: SearchedValclient.client,
        page_size: 20,
        page: 1,
        data: data,
        client: clients.parent,
      };
      dispatch(setClientBranchSearchAction(payload));
    }
  }, [
    SearchedValclient.client,
    data,
    clients.parent,
    isNonWorking,
    isNoticeOrSeparation,
    isDenaveSelf,
    isSonyOffer,
    isIdCard,
    idCardOrganization,
  ]);
  useEffect(() => {
    const payload = {
      search: SearchedValclient.parent,
      page_size: 20,
      page: 1,
    };
    dispatch(SetClientActions(payload));
  }, [SearchedValclient.parent, data]);
  useEffect(() => {
    if (state.ClientList.ClientLists != undefined) {
      let objectArray = [];
      state.ClientList.ClientLists.forEach((element) => {
        objectArray.push({
          value: element.id,
          label: element.client_name,
        });
      });
      setOptionsclientParent(objectArray);
    }
  }, [state.ClientList.ClientLists, SearchedValclient.parent]);

  // console.log(nameListclientParent ,"98273nameListclientParent");

  useEffect(() => {
    if (state.BranchSearchpart.BranchSearch != undefined) {
      let objectArray = [];
      state.BranchSearchpart.BranchSearch.forEach((element) => {
        objectArray.push({
          value: element.id,
          label: element.client_name,
        });
      });
      setOptionsclient(objectArray);
    }
  }, [
    state.BranchSearchpart.BranchSearch,
    SearchedValclient.client,
    clients.parent,
  ]);

  const HandleClientBranches = (selectedVal) => {
    // console.log(selectedVal.value, "va;lusfodcn ");
    if (selectedVal != null) {
      setCLientVal(selectedVal);
      setclientid({
        ...clients,
        client: selectedVal.value,
      });
    } else {
      setCLientVal({ value: "", label: "Select" });
      setclientid({
        ...clients,
        client: "",
      });
    }
  };

  const HandleClientParents = (selectedVal) => {
    // console.log(selectedVal.value, "va;lusfodcn ");
    if (selectedVal != null) {
      setclientalues(selectedVal);
      setclientid({
        ...clients,
        parent: selectedVal.value,
        client: "",
      });
    } else {
      setclientalues({ value: "", label: "Select" });
      setclientid({
        ...clients,
        parent: "",
        client: "",
      });
    }
  };

  ///-----------------search-----\

  const handleInputChangeClinet = (Val) => {
    setSearchDebounance({
      ...SearchDebounance,
      client: Val,
    });
  };

  const handleInputChangeClinetParent = (e) => {
    setSearchDebounance({
      ...SearchDebounance,
      parent: e,
    });
  };

  //----Regions-----------------
  //----Region----------------
  const handelRegionSlect = (selectedVal) => {
    if (selectedVal != null) {
      setMuliselect1(selectedVal);
      setData({
        ...data,
        region: selectedVal.value,
      });
    }
    if (selectedVal == null && data.state == null && data.zone == null) {
      setData({
        ...data,
        region: "",
        zone: "",
      });
    }
    if (selectedVal == null) {
      setData({
        ...data,
        region: "",
        zone: "",
      });

      setMuliselect1({ value: "", label: "ALL" });
      setMuliselect3({ value: "", label: "ALL" });
    }
  };

  //----Handle----Remove -----in----Regions
  const handleRemove = (e) => {
    setMuliselect1(e);
    setData({
      ...data,
      region: "",
    });
  };

  //----------------Zone
  const handleZone = (selectedVal) => {
    if (selectedVal != null) {
      setMuliselect3(selectedVal);
      setData({
        ...data,
        zone: selectedVal.value,
      });
    }
    if (selectedVal == null && data.region == null && data.state == null) {
      setData({
        ...data,
        zone: "",
      });
    }
    if (selectedVal == null) {
      setMuliselect3({ value: "search", label: "Search" });
    }
  };
  //---Region-----------------
  const handleInputRegion = (Val) => {
    setSearchDebounance({
      ...SearchDebounance,
      regionSearch: Val,
    });
  };
  ///----Zone---Name
  const handleInputZone = (Val) => {
    setSearchDebounance({
      ...SearchDebounance,
      zoneSearch: Val,
    });
  };

  ///----State----------Changes-----------------------
  const handleSelectChange = (selectedVal) => {
    if (selectedVal != null) {
      setMuliselect(selectedVal);
      setMuliselect1({ value: "", label: "ALL" });
      setMuliselect3({ value: "", label: "ALL" });
      setData({
        ...data,
        state: selectedVal.value,
        region: "",
        zone: "",
      });
      setclientid({
        ...clients,
        client: "",
      });
    }
    setCLientVal({ value: "", label: "Select" });

    if (selectedVal == null) {
      setMuliselect({ value: "", label: "ALL" });
      setMuliselect1({ value: "search", label: "Search" });
      setMuliselect3({ value: "search", label: "Search" });
      setData({
        ...data,
        state: "",
        region: "",
        zone: "",
      });
      setCLientVal({ value: "", label: "Select" });
    }
  };

  ///--------------Organizations-----------------
  useEffect(() => {
    const payloads = {
      search: SearchedVal.organization_search,
      page_size: 20,
      page: 1,
    };
    dispatch(resetOrganizationFilterlist(payloads));
  }, [SearchedVal.organization_search]);

  useEffect(() => {
    if (state.organization_filterlist_tocall.Organization_filterlist_records) {
      let ObjectArrayFormager = [];

      state.organization_filterlist_tocall.Organization_filterlist_records.forEach(
        (element) => {
          ObjectArrayFormager.push({
            value: element.id,
            label: element.organization_name,
          });
        },
      );
      setOrganizations_options(ObjectArrayFormager);
    }
  }, [
    state.organization_filterlist_tocall.Organization_filterlist_records,
    SearchedVal.organization_search,
  ]);
  const predefinedBottomRanges = [
    {
      label: "Today",
      value: [new Date(), new Date()],
      placement: "left",
    },
    {
      label: "Yesterday",
      value: [addDays(new Date(), -1), addDays(new Date(), -1)],
      placement: "left",
    },
    {
      label: "This week",
      value: [startOfWeek(new Date()), endOfWeek(new Date())],
      placement: "left",
    },
    {
      label: "Last week",
      value: (value, index) => {
        const [start = new Date()] = value[index] || [];
        return [
          addDays(startOfWeek(start, { weekStartsOn: 0 }), -7),
          addDays(endOfWeek(start, { weekStartsOn: 0 }), -7),
        ];
      },
      placement: "left",
    },
    {
      label: "Last 30 days",
      value: [subDays(new Date(), 29), new Date()],
      placement: "left",
    },
  ];

  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

  const validateTags = (tags) => {
    const uniqueTags = new Set();
    for (const tag of tags) {
      if (!emailRegex.test(tag)) {
        return "One or more email addresses are invalid.";
      }
      if (uniqueTags.has(tag)) {
        return "Duplicate email addresses are not allowed.";
      }
      uniqueTags.add(tag);
    }
    return "";
  };

  const openMe = () => {
    const rsAnimFade = document.querySelector(".rs-anim-fade");
    if (rsAnimFade) {
      rsAnimFade.style.setProperty("left", "1095.89px", "important");
      rsAnimFade.style.setProperty("top", "274.062px", "important");
    }
  };

  const CloseDateRange = () => {
    const rsAnimFade = document.querySelector(".rs-anim-fade");
    if (rsAnimFade) {
      rsAnimFade.style.setProperty("display", "none", "important");
      // rsAnimFade.style.setProperty('top', '184.109px', 'important');
    }
  };

  console.log(range, "asiduapsidopidas");
  const getZoomFactor = () => {
    const zoom = document.body.style.zoom;
    return zoom ? parseFloat(zoom) / 100 : 1;
  };

  const alignDateRangePicker = (pickerNode) => {
    const picker = pickerNode?.root || pickerNode?.container || pickerNode;

    const popup = document.querySelector(
      ".rs-picker-popup.rs-picker-popup-daterange",
    );

    if (!picker || !popup) return;

    const zoom = getZoomFactor();
    const rect = picker.getBoundingClientRect();

    const popupWidth = popup.offsetWidth;
    const popupHeight = popup.offsetHeight;

    const viewportWidth = window.innerWidth / zoom;
    const viewportHeight = window.innerHeight / zoom;

    const scrollX = window.scrollX / zoom;
    const scrollY = window.scrollY / zoom;

    let left = rect.right / zoom - popupWidth + scrollX;
    let top = rect.bottom / zoom + 8 + scrollY;

    if (left < 8) left = 8;
    if (left + popupWidth > viewportWidth - 8) {
      left = viewportWidth - popupWidth - 8;
    }

    if (top + popupHeight > viewportHeight + scrollY - 8) {
      top = rect.top / zoom - popupHeight - 8 + scrollY;
    }

    popup.style.position = "absolute";
    popup.style.left = `${left}px`;
    popup.style.top = `${top}px`;
  };

  const getDateDiffInDays = (from, to) => {
    const start = new Date(from);
    const end = new Date(to);

    // normalize to midnight
    start.setHours(0, 0, 0, 0);
    end.setHours(0, 0, 0, 0);

    const diffTime = end - start;
    return diffTime / (1000 * 60 * 60 * 24);
  };

  return (
    <>
      <div className={stateDisplay ? " POPUP" : "outerPOPUP"}>
        <div className="col BodyContent">
          <div className="card">
            <div className="card-body cards ">
              <div className="UserPoup">
                <div className="BeforForms">
                  <div className="Form">
                    <div className="ModalHeader">
                      <div>REPORT</div>
                      <div
                        className="CloseIcon"
                        // onClick={(e) => (window.location.href = "/reportsheet")}
                        onClick={(e) => setshow(false)}
                      >
                        <CloseOutlinedIcon />
                      </div>
                    </div>

                    <div className="Modal-Body">
                      <div
                        className="row Filters"
                        style={{
                          padding: "34px 0px",
                          margin: "0px",
                          position: "relative",
                          marginTop: "-30xp",
                          marginLeft: "0px",
                          marginRight: "0px",
                          top: "-30px",
                        }}
                      >
                        <div className="col-sm-3 mt-4">
                          <label for="validationCustom01" class="form-label">
                            REPORT
                          </label>
                          <span style={{ color: "red" }}>*</span>
                          <Select
                            styles={{ position: "relative", top: "60px" }}
                            options={reportoptions}
                            onChange={(e) => {
                              setReportVal(e);
                              if (e != null) {
                                setName({
                                  ...Name,
                                  report_type: e.value,
                                });
                                if (
                                  e.value == "onboarder_details" ||
                                  e.value == "onboarding_count_details" ||
                                  e.value == "form_export" ||
                                  e.value == "salary_report" ||
                                  e.value == "count_report" ||
                                  e.value == "attendance_report" ||
                                  e?.value == "Attendance_summary" ||
                                  e.value === "attendance_report_pdf" ||
                                  e.value === "Attendance_summary_pdf"
                                ) {
                                  setEmpRoleSele([
                                    {
                                      value: "2",
                                      label: "Client",
                                    },
                                  ]);

                                  setFilters({
                                    ...filterForWhite,
                                    white_collar: false,
                                  });
                                  setoldEmployees({
                                    ...old_employeeVal,
                                    old_employee: false,
                                  });
                                  setemplyoyeeDetails(EmployeeDetails[0]);
                                } else {
                                  setEmpRoleSele([
                                    {
                                      value: "1",
                                      label: "UDS",
                                    },
                                  ]);
                                  setclientid({
                                    ...clients,
                                    client: "",
                                  });

                                  setFilters({
                                    ...filterForWhite,
                                    white_collar: true,
                                  });
                                }

                                if (e.value == "user_cost_report") {
                                  setFilters({
                                    ...filterForWhite,
                                    white_collar: false,
                                  });
                                  setEmpRoleSele([
                                    {
                                      value: "2",
                                      label: "Client",
                                    },
                                  ]);
                                }
                                setNameerr("");
                              }
                            }}
                            value={ReportVal}
                          />
                          <p
                            className="Error"
                            style={{ paddingLeft: "5px", paddingTop: "12px" }}
                          >
                            {nameErr}
                          </p>
                        </div>
                        {Name.report_type !== "count_report" &&
                          !isNoticeOrSeparation &&
                          !isNonWorking &&
                          // employee designation not needed for denave self onboarding / sony offer / id card reports
                          !isOrgClientReport &&
                          !isIdCard && (
                          <div class=" col-sm-3 mt-4" style={{ zIndex: "10" }}>
                            <label
                              for="validationCustom02"
                              class="form-label FilterLabel"
                            >
                              EMPLOYEE DESIGANTION
                            </label>

                            <Select
                              styles={{ position: "relative", top: "60px" }}
                              onChange={(e) => {
                                HandleEMprole(e);
                              }}
                              value={EMpROleSelected}
                              options={EmpRoles}
                              placeholder="search"
                              isDisabled={
                                Name.report_type == "form_export" ||
                                Name.report_type == "salary_report" ||
                                Name.report_type == "Attendance_summary" ||
                                Name.report_type ==
                                  "onboarding_count_details" ||
                                Name.report_type === "attendance_report_pdf" ||
                                Name.report_type === "Attendance_summary_pdf" ||
                                Name.report_type == "onboarder_details" ||
                                Name.report_type == "user_cost_report"
                                  ? true
                                  : false
                              }
                            />
                          </div>
                        )}

                        {isNoticeOrSeparation ||
                        isNonWorking ||
                        isOrgClientReport ||
                        isIdCard ||
                        Name.report_type == "attendance_report" ||
                        Name.report_type == "form_export" ||
                        Name.report_type == "salary_report" ||
                        Name.report_type === "attendance_report_pdf" ||
                        Name.report_type === "Attendance_summary_pdf" ||
                        Name.report_type == "onboarding_count_details" ||
                        Name?.report_type == "Attendance_summary" ||
                        Name.report_type == "count_report" ||
                        Name.report_type == "onboarder_details" ||
                        Name.report_type == "user_cost_report" ? (
                          <>
                            <div class=" col-sm-3 mt-4">
                              <label
                                for="validationCustom02"
                                class="form-label FilterLabel"
                              >
                                FROM DATE - TO DATE
                                {!isNonWorking && !isOrgClientReport && !isIdCard && (
                                  <span style={{ color: "red" }}>*</span>
                                )}
                              </label>

                              <DateRangePicker
                                className="Dateranger"
                                //   style={{ width: 270, padding: 10 }}
                                //     onOpen={() => {
                                //       openMe()
                                //     }}
                                //  onClose={() => {
                                //     CloseDateRange()
                                //        }}
                                value={date_ranges}
                                ref={dateRangeRef}
                                onOpen={() => {
                                  setTimeout(() => {
                                    alignDateRangePicker(dateRangeRef.current);
                                  }, 80);
                                }}
                                style={{
                                  width: "100%",
                                  padding: "0px 5px",
                                  position: "relative",
                                  zIndex: 0,
                                }} // Adjust the width and padding as needed
                                placeholder="From-To"
                                // defaultValue={[new Date(), new Date()]}
                                onChange={(e) => {
                                  setFromErr("");
                                  if (e != null) {
                                    e.forEach((newValue) => {
                                      const tzoffset =
                                        new Date().getTimezoneOffset() * 60000; // offset in milliseconds
                                      const localISOTime = new Date(
                                        newValue - tzoffset,
                                      )
                                        .toISOString()
                                        .slice(0, -1);
                                      // handlechangedate(localISOTime);
                                      const [startDate, endDate] = e;

                                      // const diffDays = differenceInDays(endDate, startDate);
                                      const diffDays = differenceInDays(
                                        endDate,
                                        startDate,
                                      );

                                      if (
                                        Name.report_type ===
                                          "attendance_report_pdf" ||
                                        Name.report_type ===
                                          "Attendance_summary_pdf"
                                      ) {
                                        console.log(
                                          diffDays,
                                          "aspiduaps ddiffDays",
                                        );

                                        if (diffDays === 30) {
                                          // Since we are using inclusive range, difference should be 30 for 31 days
                                          setrange([]);
                                          e.forEach((newValue) => {
                                            const tzoffset =
                                              new Date().getTimezoneOffset() *
                                              60000; // offset in milliseconds
                                            const localISOTime = new Date(
                                              newValue - tzoffset,
                                            )
                                              .toISOString()
                                              .slice(0, -1);
                                            setdate_ranges(e);
                                            handlechangedate(localISOTime);
                                          });
                                        } else if (diffDays < 30) {
                                          setrange([]);
                                          e.forEach((newValue) => {
                                            const tzoffset =
                                              new Date().getTimezoneOffset() *
                                              60000; // offset in milliseconds
                                            const localISOTime = new Date(
                                              newValue - tzoffset,
                                            )
                                              .toISOString()
                                              .slice(0, -1);
                                            setdate_ranges(e);
                                            handlechangedate(localISOTime);
                                          });
                                        } else {
                                          setdate_ranges(null);
                                          setrange([]);
                                          toast.error(
                                            "Please select a range of exactly 31 days.",
                                            {
                                              position:
                                                toast.POSITION.TOP_RIGHT,
                                            },
                                          );
                                        }
                                      } else {
                                        setdate_ranges(e);
                                        handlechangedate(localISOTime);
                                      }
                                    });
                                  } else if (isNonWorking || isOrgClientReport || isIdCard) {
                                    // dates are optional here, so clearing must drop old values
                                    setdate_ranges(null);
                                    setrange([]);
                                  }
                                }}
                                showHeader={false}
                                size="lg"
                                ranges={predefinedBottomRanges}
                                // value={selectedDates}
                                onClean={(e) => cleaningrange(e)}
                              />

                              <p
                                className="Error"
                                style={{
                                  paddingLeft: "5px",
                                  paddingTop: "12px",
                                }}
                              >
                                {fromErr}
                              </p>
                            </div>

                            {Name.report_type == "attendance_report" ||
                            Name.report_type === "attendance_report_pdf" ? (
                              <div class=" col-sm-3 mt-4">
                                <label
                                  for="validationCustom02"
                                  class="form-label FilterLabel"
                                >
                                  EMPLOYEE
                                </label>

                                <Select
                                  styles={{ position: "relative", top: "60px" }}
                                  onChange={(e) => {
                                    setOptionsVal(e);
                                    setDateFormate(e.value);
                                  }}
                                  value={OPtionsVal}
                                  options={Options}
                                  placeholder="search"
                                />
                              </div>
                            ) : null}
                          </>
                        ) : null}
                        {(Name.report_type == "form_export" ||
                          Name.report_type == "salary_report") &&
                        !filterForWhite.white_collar ? (
                          <div class=" col-sm-3 mt-4">
                            <label
                              for="validationCustom02"
                              class="form-label FilterLabel"
                            >
                              EMPLOYEE
                            </label>

                            <Select
                              styles={{ position: "relative", top: "60px" }}
                              onChange={(e) => {
                                setemplyoyeeDetails(e);
                                setoldEmployees({
                                  ...old_employeeVal,
                                  old_employee: e.value == "1",
                                });
                              }}
                              value={EmployeeDetailsVAL}
                              options={EmployeeDetails}
                              placeholder="search"
                            />
                          </div>
                        ) : null}

                        {!isNoticeOrSeparation && !isNonWorking && (
                        <div className="col-sm-3 mt-4">
                          <label for="validationCustom01" class="form-label">
                            STATE
                          </label>
                          <Select
                            styles={{ position: "relative", top: "60px" }}
                            onSelect={(e) => {
                              setMuliselect(e);
                            }}
                            onChange={(e) => {
                              setMuliselect1([]);
                              setMuliselect3([]);
                              handleSelectChange(e);
                            }}
                            isClearable={true}
                            options={nameList}
                            onremoved={(e) => {
                              setMuliselect(e);
                            }}
                            onInputChange={(Val) => {
                              setSearchDebounance({
                                ...SearchDebounance,
                                stateSearch: Val,
                              });
                            }}
                            labelledBy="Select"
                            value={multiselect}
                          />
                        </div>
                        )}
                        {!isNoticeOrSeparation && !isNonWorking && (
                        <div className="col-sm-3 mt-4">
                          <label for="validationCustom01" class="form-label">
                            REGION
                          </label>
                          <Select
                            styles={{ position: "relative", top: "60px" }}
                            onSelect={(e) => setMuliselect1(e)}
                            onChange={(e) => {
                              setMuliselect3([]);
                              handelRegionSlect(e);
                            }}
                            options={nameList2}
                            labelledBy="Select"
                            isClearable={true}
                            onremoved={(e) => {
                              handleRemove(e);
                            }}
                            value={multiselect1}
                            onInputChange={handleInputRegion}
                          />
                        </div>
                        )}
                        {!isNoticeOrSeparation && !isNonWorking && (
                        <div className="col-sm-3 mt-4">
                          <label for="validationCustom01" class="form-label">
                            ZONE
                          </label>
                          <Select
                            styles={{ position: "relative", top: "60px" }}
                            onSelect={(e) => setMuliselect3(e)}
                            onChange={(e) => {
                              handleZone(e);
                            }}
                            options={nameList4}
                            isClearable={true}
                            onremoved={(e) => {
                              setMuliselect3(e);
                            }}
                            value={multiselect3}
                            onInputChange={handleInputZone}
                            labelledBy="Select"
                          />
                        </div>
                        )}
                        {Name.report_type == "user_cost_report" ? (
                          <>
                            <div
                              class=" col-sm-3 mt-4"
                              style={{ zIndex: "10" }}
                            >
                              <label
                                for="validationCustom02"
                                class="form-label FilterLabel"
                              >
                                SERVICE TYPE
                              </label>

                              <Select
                                styles={{ position: "relative", top: "60px" }}
                                onChange={(e) => {
                                  Handleservicetype(e);
                                }}
                                value={Servicetyp}
                                // options={API_reports}
                                options={UserReportOptions}
                                placeholder="search"
                              />
                            </div>
                          </>
                        ) : null}
                        {Name.report_type == "user_cost_report" ? (
                          <>
                            <div class=" col-sm-3 mt-4">
                              <label
                                for="validationCustom02"
                                class="form-label FilterLabel"
                              >
                                RECHARGED DATE
                              </label>

                              <Select
                                styles={{ position: "relative", top: "60px" }}
                                onChange={(e) => {
                                  // Handleservicetype(e);
                                  // settherecargeddate(e);
                                  Handletherechareddate(e);
                                }}
                                value={reachargedDtae}
                                options={UserReportRechargedOptions}
                                placeholder="search"
                              />
                            </div>
                          </>
                        ) : null}
                        {/* { Name.report_type !=  "user_cost_report"  || 
                        Name?.report_type == "Attendance_summary" 


&& !filterForWhite.white_collar  &&         
                         Name.report_type == "attendance_report" ? (
                          <div className="col-sm-3  mt-4 field-div">
                            <label for="validationCustom01" class="form-label">
                              CLIENT PARENT
                            </label>
                            <Select
                              styles={{ position: "relative", top: "60px" }}
                              onChange={(e) => {
                                HandleClientParents(e);
                              }}
                              isClearable="true"
                              options={nameListclientParent}
                              onInputChange={handleInputChangeClinetParent}
                              placeholder="search"
                               value={clientvalues}
                            />
                          </div>
                        ) : null}

                        { Name.report_type !=  "user_cost_report"  && !filterForWhite.white_collar  &&
                        Name.report_type == "attendance_report" 
                                         ||       Name?.report_type == "Attendance_summary" 

                        ? (
                          <div className="col-sm-3  mt-4 field-div">
                            <label for="validationCustom01" class="form-label">
                              BRANCH 
                            </label>
                            <Select
                              styles={{ position: "relative", top: "60px" }}
                              onChange={(e) => {
                                HandleClientBranches(e);
                              }}
                              isClearable="true"
                              options={nameListclient}
                              onInputChange={handleInputChangeClinet}
                              placeholder="search"
                               value={ClientListVal}
                            />
                          </div>
                        ) : null} */}
                        {((!filterForWhite.white_collar &&
                          (Name.report_type === "attendance_report" ||
                            Name?.report_type == "Attendance_summary" ||
                            Name.report_type === "attendance_report_pdf" ||
                            Name.report_type == "count_report" ||
                            Name.report_type === "Attendance_summary_pdf") &&
                          Name.report_type != "user_cost_report")) && (
                            <div className="col-sm-3 mt-4 field-div">
                              <label
                                htmlFor="validationCustom01"
                                className="form-label"
                              >
                                CLIENT PARENT
                              </label>
                              <Select
                                styles={{ position: "relative", top: "60px" }}
                                onChange={HandleClientParents}
                                isClearable
                                options={nameListclientParent}
                                onInputChange={handleInputChangeClinetParent}
                                placeholder="search"
                                value={clientvalues}
                              />
                            </div>
                          )}

                        {isIdCard && (
                          <div className="col-sm-3 mt-4">
                            <label
                              for="validationCustom02"
                              class="form-label FilterLabel"
                            >
                              ORGANIZATION
                            </label>

                            <Select
                              styles={{ position: "relative", top: "60px" }}
                              onChange={(e) => {
                                setIdCardOrganization(e || { value: "", label: "ALL" });
                                // clients belong to an organization, so clear the old picks
                                setMultiClients([]);
                              }}
                              options={idCardOrganizationOptions}
                              isClearable
                              value={idCardOrganization}
                            />
                          </div>
                        )}
                        {(isOrgClientReport || isIdCard) && (
                          <div className="col-sm-3 mt-4 field-div">
                            <label
                              htmlFor="validationCustom01"
                              className="form-label"
                            >
                              CLIENT
                            </label>
                            <Select
                              styles={{ position: "relative", top: "60px" }}
                              isMulti
                              isClearable
                              closeMenuOnSelect={false}
                              onChange={(selected) =>
                                setMultiClients(selected || [])
                              }
                              options={nameListclient}
                              onInputChange={handleInputChangeClinet}
                              placeholder="search"
                              value={multiClients}
                            />
                          </div>
                        )}
                        {((!filterForWhite.white_collar &&
                          (Name.report_type === "attendance_report" ||
                            Name?.report_type == "Attendance_summary" ||
                            Name.report_type === "attendance_report_pdf" ||
                            Name.report_type == "count_report" ||
                            Name.report_type === "Attendance_summary_pdf") &&
                          Name.report_type != "user_cost_report") ||
                          isNonWorking ||
                          isNoticeOrSeparation) && (
                            <div className="col-sm-3 mt-4 field-div">
                              <label
                                htmlFor="validationCustom01"
                                className="form-label"
                              >
                                BRANCH
                              </label>
                              <Select
                                styles={{ position: "relative", top: "60px" }}
                                onChange={HandleClientBranches}
                                isClearable
                                options={nameListclient}
                                onInputChange={handleInputChangeClinet}
                                placeholder="search"
                                value={ClientListVal}
                              />
                            </div>
                          )}
                        {(Name.report_type == "form_export" ||
                          Name.report_type == "salary_report" ||
                          Name.report_type == "onboarder_details") && (
                          <div class=" col-sm-3 mt-4">
                            <label
                              for="validationCustom02"
                              class="form-label FilterLabel"
                            >
                              TYPE OF EXPORTS
                            </label>

                            <Select
                              styles={{ position: "relative", top: "60px" }}
                              onChange={(e) => {
                                setfrom_export_excel(e);
                              }}
                              isDisabled={old_employeeVal?.old_employee == true}
                              value={from_export_excel}
                              options={form_export_excel_options}
                              placeholder="search"
                            />
                          </div>
                        )}

                        {!filterForWhite.white_collar &&
                          Name.report_type === "Attendance_summary_pdf" && (
                            <div className="col-sm-3 mt-4 field-div">
                              <label
                                htmlFor="validationCustom01"
                                className="form-label"
                              >
                                ADAPTIONS TYPE
                              </label>
                              <Select
                                styles={{ position: "relative", top: "60px" }}
                                onChange={(e) => {
                                  setadoption_type(e);
                                }}
                                options={adoptions_options}
                                placeholder="search"
                                value={adoption_type}
                              />
                            </div>
                          )}

                        {!filterForWhite.white_collar &&
                          (Name.report_type === "attendance_report_pdf" ||
                            Name.report_type === "Attendance_summary_pdf") && (
                            <div className="col-sm-3 mt-4 field-div">
                              <label
                                htmlFor="validationCustom01"
                                className="form-label"
                              >
                                EXPORT TYPE
                              </label>
                              <Select
                                styles={{ position: "relative", top: "60px" }}
                                onChange={(e) => {
                                  settype_ofexports(e);
                                }}
                                options={typeof_exports_options}
                                placeholder="search"
                                value={type_of_exports}
                              />
                            </div>
                          )}
                        {(Name.report_type === "form_export" ||
                          Name.report_type === "onboarder_details") && (
                          <div className="col-sm-3 mt-4">
                            <label
                              for="validationCustom02"
                              class="form-label FilterLabel"
                            >
                              ORGANIZATION
                            </label>

                            <Select
                              styles={{ position: "relative", top: "60px" }}
                              onChange={(e) => {
                                setOrganizationSelectedList(e);
                              }}
                              options={Organization_options}
                              labelledBy="Select"
                              onInputChange={(val) => {
                                setSearchDebounance({
                                  ...SearchDebounance,
                                  organization_search: val,
                                });
                              }}
                              value={
                                organizationSelectedList &&
                                organizationSelectedList
                              }
                            />
                          </div>
                        )}
                        {isIdCard && (
                          <div className="col-sm-3 mt-4">
                            <label
                              for="validationCustom02"
                              class="form-label FilterLabel"
                            >
                              ID CARD STATUS
                            </label>

                            <Select
                              styles={{ position: "relative", top: "60px" }}
                              onChange={(e) => {
                                setIdCardStatus(e || idCardStatusOptions[0]);
                              }}
                              options={idCardStatusOptions}
                              value={idCardStatus}
                            />
                          </div>
                        )}
                        <div className="col-sm-3 mt-4">
                          <label for="validationCustom01" class="form-label">
                            EMAIL
                          </label>

                          <TagsInput
                            value={emailTags.tags}
                            onChange={(e) => {
                              if (e.length <= 3) {
                                // setEmailTags({ ...emailTags, tags: e });
                                const error = validateTags(e);
                                if (error) {
                                  setEmailError(error);
                                } else {
                                  setEmailTags({ ...emailTags, tags: e });
                                  setEmailError(""); // Clear error message if valid
                                }
                              }
                            }}
                            placeHolder="Enter Email I'd"
                          />

                          <p className="Error"> {emailError} </p>
                        </div>
                      </div>
                    </div>

                    <div
                      className="UserButtons"
                      style={{
                        marginTop: "20px",
                        gap: "20px",
                        display: "flex",
                        padding: "20px",
                        justifyContent: "flex-end",
                      }}
                    >
                      <button
                        class="btn  ButtonCSS"
                        type="submit"
                        style={{ background: "#F15D39" }}
                        onClick={(e) => {
                          var a = 0;
                          if (Name.report_type == "") {
                            setNameerr("Report Name is required");
                            a = 1;
                          }
                          const isMonthlyReport =
                            Name.report_type === "attendance_report_pdf" ||
                            Name.report_type === "Attendance_summary_pdf";

                          if (
                            Name.report_type !== "" &&
                            (Name.report_type === "attendance_report" ||
                              Name.report_type === "onboarding_count_details" ||
                              Name.report_type === "onboarder_details" ||
                              Name.report_type === "attendance_report_pdf" ||
                              Name.report_type === "Attendance_summary_pdf" ||
                              // Name.report_type === "user_cost_report"
                              Name.report_type === "form_export" ||
                              Name.report_type === "salary_report") &&
                            (Name.report_type === "attendance_report" ||
                              Name.report_type === "form_export" ||
                              Name.report_type === "salary_report" ||
                              Name.report_type === "onboarding_count_details" ||
                              Name.report_type === "onboarder_details" ||
                              Name.report_type === "attendance_report_pdf" ||
                              Name.report_type === "Attendance_summary_pdf") &&
                            // ||
                            // Name.report_type === "user_cost_report"
                            // (range[0] === "" || range[1] === "")
                            range.length == 0
                          ) {
                            console.log(range, "sdiasid range");

                            setFromErr("*From date & To date are required");
                            a = 1;
                          }

                          if (
                            Name.report_type !== "" &&
                            isMonthlyReport &&
                            range.length === 2
                          ) {
                            const daysDiff = getDateDiffInDays(
                              range[0],
                              range[1],
                            );

                            if (daysDiff > 30) {
                              setFromErr(
                                "*Maximum date range allowed is 30 days",
                              );
                              a = 1;
                            }
                          }

                          if (isNoticeOrSeparation && range.length == 0) {
                            setFromErr("*From date & To date are required");
                            a = 1;
                          }

                          if (a == 0) {
                            const payload = {
                              data: {
                                report_type: Name.report_type,
                                email:
                                  (Name.report_type === "separation_report" ||
                                    isNonWorking) &&
                                  !emailTags?.tags?.length
                                    ? null
                                    : emailTags.tags,
                              },
                              paramsdata: {
                                params: isIdCard
                                  ? {
                                      // only send the filters the user filled
                                      ...(data.state && { state: data.state }),
                                      ...(data.region && { region: data.region }),
                                      ...(data.zone && { zone: data.zone }),
                                      ...(multiClients.length > 0 && {
                                        client: multiClients
                                          .map((c) => c.value)
                                          .join(","),
                                      }),
                                      ...(range.length >= 2 && {
                                        from_date: secondLastElement,
                                        to_date: lastElement,
                                      }),
                                      ...(idCardStatus?.value && {
                                        status: idCardStatus.value,
                                      }),
                                      ...(idCardOrganization?.value && {
                                        organization: idCardOrganization.value,
                                      }),
                                    }
                                  : isOrgClientReport
                                  ? {
                                      // only send the filters the user filled
                                      ...(range.length >= 2 && {
                                        from_date: secondLastElement,
                                        to_date: lastElement,
                                      }),
                                      ...(multiClients.length > 0 && {
                                        client: multiClients
                                          .map((c) => c.value)
                                          .join(","),
                                      }),
                                    }
                                  : isNonWorking
                                  ? {
                                      // only send the filters the user filled
                                      ...(range.length >= 2 && {
                                        from_date: secondLastElement,
                                        to_date: lastElement,
                                      }),
                                      ...(clients.client && {
                                        client: clients.client,
                                      }),
                                    }
                                  : isNoticeOrSeparation
                                  ? {
                                      from_date: secondLastElement,
                                      to_date: lastElement,
                                      ...(clients.client && {
                                        client: clients.client,
                                      }),
                                    }
                                  : Name.report_type == "user_cost_report"
                                    ? {
                                        state: data.state,
                                        region: data.region,
                                        zone: data.zone,
                                        api_type:
                                          Name.report_type == "user_cost_report"
                                            ? Servicetyp.label == ""
                                              ? ""
                                              : Servicetyp.label == "ZOHO"
                                                ? "0"
                                                : Servicetyp.label == "ARYA"
                                                  ? "1"
                                                  : Servicetyp.label ==
                                                      "INVINCIBLE"
                                                    ? "2"
                                                    : Servicetyp.label ==
                                                        "SANDBOX"
                                                      ? "3"
                                                      : Servicetyp.label ==
                                                          "GUPSHUP"
                                                        ? "4"
                                                        : ""
                                            : "",
                                        third_party_id:
                                          Overallstate.third_party_id,
                                        from_date:
                                          Name.report_type == "form_export" ||
                                          Name.report_type == "salary_report" ||
                                          Name.report_type ==
                                            "user_cost_report" ||
                                          Name.report_type ==
                                            "attendance_report" ||
                                          Name.report_type ==
                                            "onboarding_count_details" ||
                                          Name.report_type ==
                                            "onboarder_details"
                                            ? secondLastElement
                                            : "",
                                        to_date:
                                          Name.report_type == "form_export" ||
                                          Name.report_type == "salary_report" ||
                                          Name.report_type ==
                                            "user_cost_report" ||
                                          Name.report_type ==
                                            "attendance_report" ||
                                          Name.report_type ==
                                            "onboarding_count_details" ||
                                          Name.report_type ==
                                            "onboarder_details"
                                            ? lastElement
                                            : "",
                                        range:
                                          Name.report_type == "form_export" ||
                                          Name.report_type == "salary_report" ||
                                          Name.report_type ==
                                            "user_cost_report" ||
                                          Name.report_type ==
                                            "attendance_report" ||
                                          Name.report_type ==
                                            "onboarding_count_details" ||
                                          Name.report_type ==
                                            "onboarder_details"
                                            ? true
                                            : false,
                                      }
                                    : Name.report_type == "attendance_report"
                                      ? {
                                          state: data.state,
                                          region: data.region,
                                          zone: data.zone,
                                          client:
                                            filterForWhite.white_collar == false
                                              ? clients.client
                                              : "",
                                          parent:
                                            filterForWhite.white_collar == false
                                              ? clients.parent
                                              : "",
                                          white_collar:
                                            filterForWhite.white_collar,
                                          from_date:
                                            Name.report_type == "form_export" ||
                                            Name.report_type ==
                                              "salary_report" ||
                                            Name.report_type ==
                                              "attendance_report" ||
                                            Name.report_type ==
                                              "onboarding_count_details" ||
                                            Name.report_type ==
                                              "onboarder_details"
                                              ? secondLastElement
                                              : "",
                                          to_date:
                                            Name.report_type == "form_export" ||
                                            Name.report_type ==
                                              "salary_report" ||
                                            Name.report_type ==
                                              "attendance_report" ||
                                            Name.report_type ==
                                              "onboarding_count_details" ||
                                            Name.report_type ==
                                              "onboarder_details"
                                              ? lastElement
                                              : "",
                                          range:
                                            Name.report_type == "form_export" ||
                                            Name.report_type ==
                                              "salary_report" ||
                                            Name.report_type ==
                                              "attendance_report" ||
                                            Name.report_type ==
                                              "onboarding_count_details" ||
                                            Name.report_type ==
                                              "onboarder_details"
                                              ? true
                                              : false,

                                          base_type:
                                            Name.report_type ==
                                            "attendance_report"
                                              ? DateFormats
                                              : "",
                                          // api_type:Name.report_type=="user_cost_report"? Servicetyp.value :""
                                        }
                                      : Name?.report_type ==
                                            "Attendance_summary" ||
                                          Name?.report_type == "count_report"
                                        ? {
                                            state: data.state,
                                            region: data.region,
                                            zone: data.zone,
                                            client:
                                              filterForWhite.white_collar ==
                                              false
                                                ? clients.client
                                                : "",
                                            parent:
                                              filterForWhite.white_collar ==
                                              false
                                                ? clients.parent
                                                : "",
                                            from_date:
                                              Name.report_type ==
                                                "form_export" ||
                                              Name.report_type ==
                                                "salary_report" ||
                                              Name.report_type ==
                                                "count_report" ||
                                              Name.report_type ==
                                                "attendance_report" ||
                                              Name.report_type ==
                                                "onboarding_count_details" ||
                                              Name.report_type ==
                                                "onboarder_details" ||
                                              Name.report_type ==
                                                "Attendance_summary"
                                                ? secondLastElement
                                                : "",
                                            to_date:
                                              Name.report_type ==
                                                "form_export" ||
                                              Name.report_type ==
                                                "salary_report" ||
                                              Name.report_type ==
                                                "count_report" ||
                                              Name.report_type ==
                                                "attendance_report" ||
                                              Name.report_type ==
                                                "onboarding_count_details" ||
                                              Name.report_type ==
                                                "onboarder_details" ||
                                              Name.report_type ==
                                                "Attendance_summary"
                                                ? lastElement
                                                : "",
                                            range:
                                              Name.report_type ==
                                                "form_export" ||
                                              Name.report_type ==
                                                "salary_report" ||
                                              Name.report_type ==
                                                "count_report" ||
                                              Name.report_type ==
                                                "attendance_report" ||
                                              Name.report_type ==
                                                "onboarding_count_details" ||
                                              Name.report_type ==
                                                "onboarder_details" ||
                                              Name.report_type ==
                                                "Attendance_summary"
                                                ? true
                                                : false,

                                            // api_type:Name.report_type=="user_cost_report"? Servicetyp.value :""
                                          }
                                        : Name.report_type ==
                                            "attendance_report_pdf"
                                          ? {
                                              state: data.state,
                                              region: data.region,
                                              zone: data.zone,
                                              client:
                                                filterForWhite.white_collar ==
                                                false
                                                  ? clients.client
                                                  : "",
                                              parent:
                                                filterForWhite.white_collar ==
                                                false
                                                  ? clients.parent
                                                  : "",
                                              white_collar:
                                                filterForWhite.white_collar,
                                              from_date:
                                                Name.report_type ==
                                                "attendance_report_pdf"
                                                  ? secondLastElement
                                                  : "",
                                              to_date:
                                                Name.report_type ==
                                                "attendance_report_pdf"
                                                  ? lastElement
                                                  : "",
                                              range:
                                                Name.report_type ==
                                                "attendance_report_pdf"
                                                  ? true
                                                  : false,

                                              base_type:
                                                Name.report_type ==
                                                "attendance_report_pdf"
                                                  ? DateFormats
                                                  : "",
                                              export_type:
                                                type_of_exports?.value
                                                  ? type_of_exports?.value
                                                  : "",
                                            }
                                          : Name?.report_type ==
                                              "Attendance_summary_pdf"
                                            ? {
                                                state: data.state,
                                                region: data.region,
                                                zone: data.zone,
                                                client:
                                                  filterForWhite.white_collar ==
                                                  false
                                                    ? clients.client
                                                    : "",
                                                parent:
                                                  filterForWhite.white_collar ==
                                                  false
                                                    ? clients.parent
                                                    : "",
                                                from_date:
                                                  Name.report_type ==
                                                  "Attendance_summary_pdf"
                                                    ? secondLastElement
                                                    : "",
                                                to_date:
                                                  Name.report_type ==
                                                  "Attendance_summary_pdf"
                                                    ? lastElement
                                                    : "",
                                                range:
                                                  Name.report_type ==
                                                  "Attendance_summary_pdf"
                                                    ? true
                                                    : false,
                                                ...(adoption_type?.value !== ""
                                                  ? {
                                                      client_adoption_status:
                                                        adoption_type?.value ===
                                                        "1"
                                                          ? true
                                                          : adoption_type?.value ===
                                                              "2"
                                                            ? false
                                                            : "",
                                                    }
                                                  : {}),
                                                export_type:
                                                  type_of_exports?.value
                                                    ? type_of_exports?.value
                                                    : "",
                                              }
                                            : {
                                                state: data.state,
                                                region: data.region,
                                                zone: data.zone,
                                                client:
                                                  Name.report_type ==
                                                  "attendance_report"
                                                    ? ""
                                                    : clients.client,
                                                white_collar:
                                                  filterForWhite.white_collar,
                                                old_employee:
                                                  Name.report_type ==
                                                    "onboarding_count_details" ||
                                                  Name.report_type ==
                                                    "onboarder_details"
                                                    ? false
                                                    : old_employeeVal.old_employee,
                                                from_date:
                                                  Name.report_type ==
                                                    "form_export" ||
                                                  Name.report_type ==
                                                    "salary_report" ||
                                                  Name.report_type ==
                                                    "attendance_report" ||
                                                  Name.report_type ==
                                                    "onboarding_count_details" ||
                                                  Name.report_type ==
                                                    "onboarder_details"
                                                    ? secondLastElement
                                                    : "",
                                                to_date:
                                                  Name.report_type ==
                                                    "form_export" ||
                                                  Name.report_type ==
                                                    "salary_report" ||
                                                  Name.report_type ==
                                                    "attendance_report" ||
                                                  Name.report_type ==
                                                    "onboarding_count_details" ||
                                                  Name.report_type ==
                                                    "onboarder_details"
                                                    ? lastElement
                                                    : "",
                                                range:
                                                  Name.report_type ==
                                                    "form_export" ||
                                                  Name.report_type ==
                                                    "salary_report" ||
                                                  Name.report_type ==
                                                    "attendance_report" ||
                                                  Name.report_type ==
                                                    "onboarding_count_details" ||
                                                  Name.report_type ==
                                                    "onboarder_details"
                                                    ? true
                                                    : false,

                                                base_type:
                                                  Name.report_type ==
                                                  "attendance_report"
                                                    ? DateFormats
                                                    : "",
                                                organization:
                                                  Name.report_type ==
                                                    "form_export" ||
                                                  Name.report_type ==
                                                    "salary_report" ||
                                                  Name.report_type ==
                                                    "onboarder_details"
                                                    ? organizationSelectedList?.value
                                                    : null,
                                                awaiting_employee_sign:
                                                  Name.report_type ==
                                                    "form_export" ||
                                                  Name.report_type ==
                                                    "salary_report" ||
                                                  Name.report_type ==
                                                    "onboarder_details"
                                                    ? from_export_excel?.value ==
                                                      "awaiting_for_employee"
                                                      ? true
                                                      : null
                                                    : null,
                                                kyc_completed:
                                                  Name.report_type ==
                                                    "form_export" ||
                                                  Name.report_type ==
                                                    "salary_report" ||
                                                  Name.report_type ==
                                                    "onboarder_details"
                                                    ? from_export_excel?.value ==
                                                      "kyc_completed"
                                                      ? true
                                                      : null
                                                    : null,

                                                // api_type:Name.report_type=="user_cost_report"? Servicetyp.value :""
                                              },
                              },
                              params: {
                                state: data.state,
                                region: data.region,
                                zone: data.zone,
                                client:
                                  Name.report_type == "attendance_report"
                                    ? ""
                                    : clients.client,
                                white_collar: filterForWhite.white_collar,
                                old_employee:
                                  Name.report_type ==
                                    "onboarding_count_details" ||
                                  Name.report_type == "onboarder_details"
                                    ? false
                                    : old_employeeVal.old_employee,
                                // : Name.report_type == "attendance_report" ? "":old_employeeVal.old_employee,
                                from_date:
                                  Name.report_type == "form_export" ||
                                  Name.report_type == "salary_report" ||
                                  Name.report_type == "attendance_report" ||
                                  Name.report_type ==
                                    "onboarding_count_details" ||
                                  Name.report_type == "onboarder_details"
                                    ? secondLastElement
                                    : "",
                                to_date:
                                  Name.report_type == "form_export" ||
                                  Name.report_type == "salary_report" ||
                                  Name.report_type == "attendance_report" ||
                                  Name.report_type ==
                                    "onboarding_count_details" ||
                                  Name.report_type == "onboarder_details"
                                    ? lastElement
                                    : "",
                                range:
                                  Name.report_type == "form_export" ||
                                  Name.report_type == "salary_report" ||
                                  Name.report_type == "attendance_report" ||
                                  Name.report_type ==
                                    "onboarding_count_details" ||
                                  Name.report_type == "onboarder_details"
                                    ? true
                                    : false,

                                base_type:
                                  Name.report_type == "attendance_report"
                                    ? DateFormats
                                    : "",
                                api_type:
                                  Name.report_type == "user_cost_report"
                                    ? Servicetyp.value
                                    : "",
                                organization:
                                  Name.report_type == "form_export" ||
                                  Name.report_type == "salary_report" ||
                                  Name.report_type == "onboarder_details"
                                    ? organizationSelectedList?.value
                                    : null,
                                awaiting_employee_sign:
                                  Name.report_type == "form_export" ||
                                  Name.report_type == "salary_report" ||
                                  Name.report_type == "onboarder_details"
                                    ? from_export_excel?.value ==
                                      "awaiting_for_employee"
                                      ? true
                                      : null
                                    : null,
                                kyc_completed:
                                  Name.report_type == "form_export" ||
                                  Name.report_type == "salary_report" ||
                                  Name.report_type == "onboarder_details"
                                    ? from_export_excel?.value ==
                                      "kyc_completed"
                                      ? true
                                      : null
                                    : null,
                              },
                              callactions: {
                                search: search,
                                page_size: 10,
                                page: 1,
                                status: status,
                              },
                            };
                            console.log(payload, "werwewe");

                            dispatch(
                              getRoportpostActions(payload, setshow(false)),
                            );
                            setEmailTags([]);
                          }
                        }}
                      >
                        Create Report
                      </button>

                      <button
                        class="btn ButtonCSS"
                        style={{ background: "#F47B38" }}
                        onClick={(e) => {
                          setshow(false);
                        }}
                      >
                        Cancel
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ReportCreateSheet;
